<template>
  <v-app id="c5-wrapper">
    <usc-page-header
      :isMenuExpanded="drawer"
      @menuclicked="toggleDrawer"
    />
    <div>
    <v-navigation-drawer
      fixed
      v-model="drawer"
      class="usc-navdrawer"
      width="320"
      mobile-break-point="1024"
      disable-route-watcher
      dark
      app
    >
      <a
        tabindex="0"
        role="button"
        href="#"
        @click="toggleDrawer"
        :class="['usc-navdrawer--close-button', { hidden: !drawer }]"
        aria-label="Close menu"
        @keypress="toggleDrawer"
      >
        <v-icon>close</v-icon>
      </a>

      <div class="usc-navdrawer--logo">
        <router-link to="/" aria-label="USC Marshall School of Business - Home" title="Go to Home" tabindex="0">
          <img src="./assets/usc_marshall_logo_nav.svg" class="img-responsive" alt="USC Marshall School of Business logo - Home" title="Go to Home page">
          <span class="uscm-logotext">USC Marshall School of Business</span>
        </router-link>
      </div>

      <hr>

      <usc-sidenav-section v-for="section in $root.sidenav" :key="section.title"
        :title="section.title" :class-suffix="section.classSuffix"
        :route="section.route">
        <usc-sidenav-item v-for="item in section.items" :key="item.route"
          :route="item.route">{{ item.title }}</usc-sidenav-item>
      </usc-sidenav-section>

    </v-navigation-drawer>



    <v-content aria-live="polite">
      <v-container fluid>
        <v-slide-y-transition mode="out-in">
          <v-layout row wrap>
            <v-flex xs12>
              <router-view></router-view>
              <usc-backToTop></usc-backToTop>
              <usc-section-nav></usc-section-nav>
            </v-flex>
          </v-layout>
        </v-slide-y-transition>
      </v-container>
    </v-content>
    </div>


    <usc-footer></usc-footer>

  </v-app>
</template>

<script>
import SidenavSection from '@/components/Sidenav/SidenavSection'
import SidenavItem from '@/components/Sidenav/SidenavItem'
import SectionNav from '@/components/SectionNav'
import PageHeader from '@/components/PageHeader'
import backToTop from '@/components/BackToTop'
import footer from '@/components/Footer'

export default {
  methods: {
    toggleDrawer (event) {
      this.drawer = !this.drawer
      if (event) event.preventDefault()
    },
    updateAriaCurrent () {
      // Remove aria-current from all links
      const allLinks = document.querySelectorAll('a[aria-current="true"]')
      allLinks.forEach(link => {
        link.removeAttribute('aria-current')
      })

      // Add aria-current to the active links
      const activeLinks = document.querySelectorAll('a.router-link-active')
      activeLinks.forEach(link => {
        link.setAttribute('aria-current', 'true')
      })
    }
  },
  mounted () {
    this.updateAriaCurrent()
    this.$router.afterEach(() => {
      this.updateAriaCurrent()
    })
  },
  components: {
    'usc-sidenav-section': SidenavSection,
    'usc-sidenav-item': SidenavItem,
    'usc-section-nav': SectionNav,
    'usc-page-header': PageHeader,
    'usc-backToTop': backToTop,
    'usc-footer': footer
  },
  data () {
    return {
      drawer: window.innerWidth >= 1024
    }
  },
  watch: {
    '$route' () {
      // Check screen size, don't close the nav on desktops
      if (window.innerWidth < 1024) {
        this.drawer = false
      }
    },
    drawer (newValue) {
      if (newValue) {
        // Focus the close button
        this.$el.querySelector('.usc-navdrawer--close-button').focus()
      }
    }
  }
}
</script>

<style lang="scss">
@import '~styles/vars';
@import '~styles/typography';
@import '~styles/layout';
@import '~styles/carousel';
.container {
  padding: 0;
  padding-top: 56px;
  @media(min-width: $screen-md-min) {
    padding-top: 0;
  }
}
.uscm-logotext {
    border: 0 !important;
    clip: rect(1px, 1px, 1px, 1px);
    height: 1px !important;
    overflow: hidden;
    padding: 0 !important;
    position: absolute !important;
    white-space: nowrap;
    width: 1px !important;
    color: #fff;
    font-size: 16px;
}
.usc-navdrawer {
  // background: url(assets/sidebar_pattern.jpg);
  background: #232323 !important;
  padding-left: 38px;
  padding-top: 48px;
  &.navigation-drawer--is-mobile.navigation-drawer--open {
    .usc-navdrawer--close-button {
      display: block;
    }
  }
  &.navigation-drawer--close.navigation-drawer--fixed {
    display: none;
  }
  .usc-navdrawer--close-button {
    text-decoration: none;
    display: none;
    position: absolute;
    right: 20px;
    top: 20px;
    opacity: .5;
    cursor: pointer;
    &.hidden {
      opacity: 0;
      pointer-events: none;
    }
    &:hover {
      opacity: 1;
    }
  }
  .usc-navdrawer--logo {
    display: none;
    @media(min-width: $screen-md-min) {
      display: block;
    }
    padding-right: 150px;
  }
  hr {
    display: none;
    @media (min-width: $screen-md-min) {
      display: block;
      width: 244px;
      height: 1px;
      background-color: rgba(255,255,255,.08);
      margin: 30px 0;
      border: none;
    }
  }
  a {
    text-decoration: none;
  }
  & li {
    list-style: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue